//#region Imports
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import PersonPinCircleOutlinedIcon from '@mui/icons-material/PersonPinCircleOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import {
  ContactsOutlined,
  LocationCityOutlined,
  ManageAccountsOutlined,
  PermContactCalendarOutlined,
} from '@mui/icons-material';
import { useTranslationHook } from './hooks/UseTranslationHook';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBoxesStacked,
  faWarehouse,
  faClipboardList,
  faArrowDownArrowUp,
  faIndustryWindows,
  faShelves,
  faToolbox,
  faCalendarRange,
  faSignsPost,
  faCarWrench,
  faStore,
  faPeopleGroup,
} from '@fortawesome/pro-light-svg-icons';
import {
  faListCheck,
  faBuildingColumns,
  faIdCard,
  faFileCircleXmark,
  faListTimeline,
  faClipboardListCheck,
  faCircleLocationArrow,
  faTag,
  faCube,
} from '@fortawesome/pro-regular-svg-icons';

import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';

//#endregion

export const SidebarMenuItems = () => {
  const {
    dashboardString,
    clientsString,
    clientsCRUDStr,
    clientsSitesStr,
    clientsContactsStr,
    techsString,
    techsCRUDStr,
    techsHistoryStr,
    usersString,
    visitsString,
    visitsCRUDStr,
    visitsRejectedStr,
    visitsFollowStr,
    equipsString,
    itemsString,
    assetsString,
    inventoryString,
    inventoryWarehouseStr,
    inventoryWarehouseMStr,
    inventoryEntriesExitsStr,
    inventoryManufacturersStr,
    inventoryWarehouseAdmonStr,
    inventoryLocationsStr,
    rolesString,
    indicatorsString,
  } = useTranslationHook();

  const menuItems = [
    {
      title: dashboardString,
      path: '/dashboard',
      icon: <HomeOutlinedIcon className="icon" />,
      permission: ['Read Dashboard'],
      midisabled: false,
    },
    {
      title: 'Indicadores',
      path: '/indicators',
      icon: <AnalyticsOutlinedIcon className="icon" />,
      midisabled: false,
      permission: ['List Indicators'],
      submenutitle: indicatorsString,
      // indicatorModule: true,
    },
    // {
    //   title: 'Agenda',
    //   submenutitle: 'Agendas',
    //   path: '/agenda/week',
    //   icon: <PermContactCalendarOutlined className='icon' />,
    //   midisabled: false,
    //   agendasModule: true,
    // },
    // {
    //   title: 'Planeación anual',
    //   submenutitle: 'Agendas',
    //   path: '/agenda/year',
    //   icon: <FontAwesomeIcon icon={faCalendarRange} className='icon' />,
    //   midisabled: false,
    //   agendasModule: true,
    // },
    // {
    //   title: 'SIGMA Regiones',
    //   path: '/indicators',
    //   icon: <AnalyticsOutlinedIcon className='icon' />,
    //   midisabled: false,
    //   permission: ['List Indicators'],
    //   submenutitle: indicatorsString,
    //   indicatorModule: true,
    // },
    // {
    //   title: 'SIGMA Plazas',
    //   path: '/indicators-2',
    //   icon: <AnalyticsOutlinedIcon className='icon' />,
    //   midisabled: false,
    //   permission: ['List Indicators'],
    //   submenutitle: indicatorsString,
    //   indicatorModule: true,
    // },
    // {
    //   title: 'SIGMA Encuestas',
    //   path: '/indicators-3',
    //   icon: <AnalyticsOutlinedIcon className='icon' />,
    //   midisabled: false,
    //   permission: ['List Indicators Surveys'],
    //   submenutitle: indicatorsString,
    //   indicatorModule: true,
    // },
    {
      title: 'Regiones',
      submenutitle: clientsString,
      path: '/regions',
      icon: <FontAwesomeIcon icon={faSignsPost} className="icon" />,
      permission: ['View Regions'],
      midisabled: false,
      clientsModule: true,
    },
    {
      title: clientsCRUDStr,
      submenutitle: clientsString,
      path: '/clients',
      icon: <MenuBookOutlinedIcon className="icon" />,
      permission: ['List Clients'],
      midisabled: false,
      clientsModule: true,
    },
    {
      title: clientsSitesStr,
      submenutitle: clientsString,
      path: '/sites',
      icon: <FontAwesomeIcon icon={faStore} className='icon' />,
      permission: ['List Sites'],
      midisabled: false,
      clientsModule: true,
    },
    // {
    //   title: clientsContactsStr,
    //   submenutitle: clientsString,
    //   path: '/contacts',
    //   icon: <ContactsOutlined className='icon' />,
    //   permission: ['List Contacts'],
    //   midisabled: false,
    //   clientsModule: true,
    // },
    {
      title: 'Ubicaciones',
      submenutitle: 'Gestión de Equipos',
      path: '/locations-assets',
      permission: ['List Assets'],
      icon: <FontAwesomeIcon icon={faCircleLocationArrow} className='icon' />,
      midisabled: false,
      equipsModule: true,
    },
    {
      title: 'Marca',
      submenutitle: 'Gestión de Equipos',
      path: '/brands',
      permission: ['List Assets'],
      icon: <FontAwesomeIcon icon={faTag} className='icon' />,
      midisabled: false,
      equipsModule: true,
    },
    {
      title: 'Modelos',
      submenutitle: 'Gestión de Equipos',
      path: '/models',
      permission: ['List Assets'],
      icon: <FontAwesomeIcon icon={faCube} className='icon' />,
      midisabled: false,
      equipsModule: true,
    },
    {
      title: 'Tipos de equipos',
      submenutitle: 'Gestión de Equipos',
      path: '/equipments',
      icon: <CategoryOutlinedIcon className="icon" />,
      midisabled: false,
      equipsModule: true,
    },
    {
      title: assetsString,
      submenutitle: 'Gestión de Equipos',
      path: '/assets',
      icon: <Inventory2OutlinedIcon className="icon" />,
      midisabled: false,
      equipsModule: true,
    },
    // {
    //   title: inventoryWarehouseMStr,
    //   submenutitle: inventoryString,
    //   path: '/inventory',
    //   icon: <FontAwesomeIcon icon={faClipboardList} className='icon' />,
    //   // permission: [''],
    //   midisabled: false,
    //   inventoryModule: true,
    // },
    // {
    //   title: inventoryEntriesExitsStr,
    //   submenutitle: inventoryString,
    //   path: '/inventory/entries',
    //   icon: <FontAwesomeIcon icon={faArrowDownArrowUp} className='icon' />,
    //   // permission: [''],
    //   midisabled: false,
    //   inventoryModule: true,
    // },
    // {
    //   title: inventoryWarehouseStr,
    //   submenutitle: inventoryString,
    //   path: '/inventory/store',
    //   icon: <FontAwesomeIcon icon={faToolbox} className='icon' />,
    //   // permission: [''],
    //   midisabled: false,
    //   inventoryModule: true,
    // },
    // {
    //   title: inventoryWarehouseAdmonStr,
    //   submenutitle: inventoryString,
    //   path: '/inventory/admon',
    //   icon: <FontAwesomeIcon icon={faWarehouse} className='icon' />,
    //   // permission: [''],
    //   midisabled: false,
    //   inventoryModule: true,
    // },
    // {
    //   title: inventoryLocationsStr,
    //   submenutitle: inventoryString,
    //   path: '/inventory/locations',
    //   icon: <FontAwesomeIcon icon={faShelves} className='icon' />,
    //   // permission: [''],
    //   midisabled: false,
    //   inventoryModule: true,
    // },
    // {
    //   title: inventoryManufacturersStr,
    //   submenutitle: inventoryString,
    //   path: '/inventory/manufacturers',
    //   icon: <FontAwesomeIcon icon={faIndustryWindows} className='icon' />,
    //   // permission: [''],
    //   midisabled: false,
    //   inventoryModule: true,
    // },
    {
      title: techsCRUDStr,
      submenutitle: techsString,
      path: '/tecnicos',
      icon: <BusinessCenterOutlinedIcon className="icon" />,
      permission: ['List Technicals'],
      midisabled: false,
      techsModule: true,
    },
    {
      title: techsHistoryStr,
      submenutitle: techsString,
      path: '/historyTechs',
      icon: <PersonPinCircleOutlinedIcon className="icon" />,
      permission: ['View technical history'],
      midisabled: false,
      techsModule: true,
    },
    {
      title: visitsCRUDStr,
      submenutitle: visitsString,
      path: '/visits',
      icon: <SettingsOutlinedIcon className="icon" />,
      permission: ['List Visits'],
      midisabled: false,
      visitsModule: true,
    },
    // {
    //   title: visitsRejectedStr,
    //   submenutitle: visitsString,
    //   path: '/visits/incomplete',
    //   icon: <FontAwesomeIcon icon={faFileCircleXmark} className='icon' />,
    //   permission: ['List Visits'],
    //   midisabled: false,
    //   visitsModule: true,
    // },
    {
      title: 'Tipos de servicio',
      submenutitle: visitsString,
      path: '/serviceTypes',
      icon: <FontAwesomeIcon icon={faListCheck} className='icon' />,
      permission: ['View Failure Types'],
      midisabled: false,
      visitsModule: true,
    },
    // {
    //   title: 'Bitacora de horarios',
    //   submenutitle: visitsString,
    //   path: '/schedule-log',
    //   icon: <FontAwesomeIcon icon={faListTimeline} className='icon' />,
    //   permission: ['List Schedule Log'],
    //   midisabled: false,
    //   visitsModule: true,
    // },
    {
      title: 'Mantenimientos a tipos de equipos',
      path: '/equipments-maintenance',
      icon: <FontAwesomeIcon icon={faPeopleGroup} className="icon" />,
      permission: ['List Maintenance Equipments'],
      midisabled: false,
    },
    // {
    //   title: 'Encuestas',
    //   path: '/surveys',
    //   icon: <FontAwesomeIcon icon={faClipboardListCheck} className='icon' />,
    //   permission: ['Beta Visit Type'],
    //   midisabled: false,
    // },
    // {
    //   title: visitsFollowStr,
    //   submenutitle: visitsString,
    //   path: '/followVisits',
    //   icon: <SearchOutlinedIcon className='icon' />,
    //   permission: ['List Visits'],
    //   midisabled: false,
    //   visitsModule: true,
    // },
    // {
    //   title: usersString,
    //   path: '/users',
    //   icon: <GroupOutlinedIcon className='icon' />,
    //   permission: ['List Users'],
    //   midisabled: false,
    // },
    // {
    //   title: 'Licences',
    //   path: '/licenses',
    //   icon: <FontAwesomeIcon icon={faIdCard} className='icon' />,
    //   permission: ['Read Licenses'],
    //   midisabled: false,
    // },
    // {
    //   title: rolesString,
    //   path: '/roles',
    //   icon: <ManageAccountsOutlined className='icon' />,
    //   // permission: ['List Roles'],
    //   midisabled: false,
    // },
  ];

  return menuItems;
};
